import { MatDialogConfig } from '@angular/material/dialog';

interface ModalConfigOptions {
  smFullScreen?: boolean;
  drawer?: boolean;
  isImageOpener?: boolean;
  isVideoOpener?: boolean;
}

export const getModalConfig = (configOptions: ModalConfigOptions = {}): object => {
  const config = { panelClass: ['tp-modal'] } as MatDialogConfig & { panelClass: string[] };

  if (configOptions.drawer) {
    config.panelClass.push('tp-modal--drawer');
    config.position = { right: '0' };
  }

  if (configOptions.smFullScreen) {
    config.panelClass.push('tp-modal--sm-full');
  }

  if (configOptions.isImageOpener) {
    config.panelClass.push('tp-modal--image-opener');
  }

  if (configOptions.isVideoOpener) {
    config.panelClass.push('tp-modal--video-opener');
  }

  return config;
};
